import { render, staticRenderFns } from "./MaterialInformation.vue?vue&type=template&id=5295eee0&"
import script from "./MaterialInformation.vue?vue&type=script&lang=js&"
export * from "./MaterialInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports